import ExternalLink from "../single/externalLink";

const SectionHeadings = () => {
	return (
		<>
		<h4>Criterio 2.4.10. <ExternalLink href="https://www.w3.org/TR/WCAG21/#section-headings"
contents="Encabezados de sección" /> (nivel AAA)</h4>
		<blockquote>
		<p>Para organizar el contenido se usan encabezados de sección.</p>
		</blockquote>
		<p>Los encabezados pueden usarse en distintos tipos de contenido, como formularios, menús, etc.</p>
		</>
	)
}

export default SectionHeadings;
